/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.Login = class Login {
  constructor(el, controller) {
    this.onKeyPressed = this.onKeyPressed.bind(this);
    this.onEmailBlur = this.onEmailBlur.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.toggleTick = this.toggleTick.bind(this);
    this.emailValid = this.emailValid.bind(this);
    this.fullNameValid = this.fullNameValid.bind(this);
    this.firstNameValid = this.firstNameValid.bind(this);
    this.lastNameValid = this.lastNameValid.bind(this);
    this.customFieldValid = this.customFieldValid.bind(this);
    this.termsOptInValid = this.termsOptInValid.bind(this);
    this.emailComplianceOptInValid = this.emailComplianceOptInValid.bind(this);
    this.marketingOptInValid = this.marketingOptInValid.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.onResendJoinEmailSubmit = this.onResendJoinEmailSubmit.bind(this);
    this.getResendJoinEmailUrl = this.getResendJoinEmailUrl.bind(this);
    this.getResendJoinEmailData = this.getResendJoinEmailData.bind(this);
    this.showJoinEmailSuccess = this.showJoinEmailSuccess.bind(this);
    this.el = el;
    this.controller = controller;
    this.fullName = this.el.find('[data-input-tick="full_name"]');
    this.firstName = this.el.find('[data-input-tick="first_name"]');
    this.lastName = this.el.find('[data-input-tick="last_name"]');
    this.email = this.el.find('[data-input-tick="email"]');
    this.termsOptIn = this.el.find('[data-input-opt-in="terms"]');
    this.emailComplianceOptIn = this.el.find('[data-input-opt-in="email_compliance"]');
    this.marketingOptIn = this.el.find('[data-input-opt-in="marketing"]');
    this.marketingOptInOptional = this.marketingOptIn.data('optional');
    this.customField = this.el.find('[data-input-tick="custom-field"]');

    this.button = this.el.find('form').find('button.login-or-register');
    this.resendJoinEmailForm = this.el.find('form#resend-join-email');

    this.email.tooltipster({
      position: 'bottom',
      content: ''
    });
    this.email.tooltipster('disable');
  }

  onKeyPressed(cb) {
    this.email.on('input', 'input', cb);
    this.fullName.on('input', 'input', cb);
    this.firstName.on('input', 'input', cb);
    this.lastName.on('input', 'input', cb);
    this.termsOptIn.on('change', cb);
    this.emailComplianceOptIn.on('change', cb);
    this.marketingOptIn.on('change', cb);
    this.customField.on('input', cb);
    return this.customField.on('change', 'input', cb);
  }

  onEmailBlur(cb) {
    return this.email.on('blur', 'input', cb);
  }

  onButtonClick(cb) {
    return this.button.on('click', cb);
  }

  toggleTick() {
    this.email.toggleClass('tick', this.emailValid());
    this.fullName.toggleClass('tick', this.fullNameValid());
    this.firstName.toggleClass('tick', this.firstNameValid());
    this.lastName.toggleClass('tick', this.lastNameValid());
    return this.customField.toggleClass('tick', this.customFieldValid());
  }

  emailValid() {
    return new Buyapowa.Helpers.EmailValidator(this.email.find('input').val()).isValid();
  }

  fullNameValid() {
    const input = this.fullName.find('input');
    if (input.length === 0) { return true; }
    return new Buyapowa.Helpers.FullNameValidator(input.val(), this.fullName.data().minLength).isValid();
  }

  firstNameValid() {
    const input = this.firstName.find('input');
    if (input.length === 0) { return true; }
    return new Buyapowa.Helpers.PartialNameValidator(input.val(), this.firstName.data().minLength).isValid();
  }

  lastNameValid() {
    const input = this.lastName.find('input');
    if (input.length === 0) { return true; }
    return new Buyapowa.Helpers.PartialNameValidator(input.val(), this.lastName.data().minLength).isValid();
  }

  customFieldValid() {
    if (!this.customField.length) { return true; }
    return new Buyapowa.Helpers.CustomSignupFieldValidator(this.customField.find('input')).isValid();
  }

  termsOptInValid() {
    if (this.termsOptIn.length === 0) { return true; }
    return this.termsOptIn.find('input').is(':checked');
  }

  emailComplianceOptInValid() {
    if (this.emailComplianceOptIn.length === 0) { return true; }
    return this.emailComplianceOptIn.find('input').is(':checked');
  }

  marketingOptInValid() {
    if (this.marketingOptInOptional) { return true; }
    if (this.marketingOptIn.length === 0) { return true; }
    return this.marketingOptIn.find('input').is(':checked');
  }

  disableButton() {
    return this.button.attr('disabled','disabled');
  }

  enableButton() {
    return this.button.removeAttr('disabled');
  }

  showTooltip(text) {
    this.email.tooltipster('content', text);
    this.email.tooltipster('enable');
    return this.email.tooltipster('show');
  }

  hideTooltip() {
    this.email.tooltipster('disable');
    return this.email.tooltipster('hide', () => {
      return this.email.tooltipster('content', '');
    });
  }

  alreadySignedUp() {
    return this.resendJoinEmailForm.length;
  }

  onResendJoinEmailSubmit(cb) {
    return this.resendJoinEmailForm.on('submit', cb);
  }

  getResendJoinEmailUrl() {
    return this.resendJoinEmailForm.attr('action');
  }

  getResendJoinEmailData() {
    return this.resendJoinEmailForm.serializeObject();
  }

  showJoinEmailSuccess() {
    this.el.find('.already-signed-up').addClass('hide');
    return this.el.find('.join-email-resent').removeClass('hide');
  }

  buttonProgressText() {
    return this.el.data('button-progress-text');
  }

  invalidEmailTooltip() {
    return this.el.data('invalid-email-tooltip');
  }
};
